import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Leaf, HeartHandshake, Wind, MessageCircle, BookOpen, BookOpenCheck, Lock, Menu, X } from 'lucide-react';

const navItems = [
  { id: 'meditations', label: 'Meditations', icon: Leaf, route: null },
  { id: 'affirmations', label: 'Affirmations', icon: HeartHandshake, route: null },
  { id: 'box-breathing', label: 'Box Breathing', icon: Wind, route: null },
  { id: 'blog-guides', label: 'Blog & Guides', icon: BookOpen, route: '/blogs' },
  { id: 'feedback', label: 'Community Feedback', icon: MessageCircle, route: null },
  { id: 'creator', label: "Creator's Story", icon: BookOpenCheck, route: null },
];

const Header = ({ onAdminClick, onNavigate }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  const goto = (item) => {
    setOpen(false);
    if (item.route) { navigate(item.route); return; }
    // Section anchor: smooth-scroll if on home, else navigate home with hash
    if (isHome) {
      const el = document.getElementById(item.id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (onNavigate) onNavigate(item.id);
    } else {
      navigate(`/#${item.id}`);
    }
  };

  const gotoHero = () => {
    setOpen(false);
    if (isHome) {
      const el = document.getElementById('hero');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      navigate('/');
    }
  };

  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur border-b border-emerald-100">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 py-3 gap-4">
        <button onClick={gotoHero} className="flex items-center gap-3 text-left">
          <div className="w-11 h-11 rounded-full bg-gradient-to-br from-emerald-500 to-emerald-700 flex items-center justify-center shadow-md shadow-emerald-200">
            <Leaf className="w-5 h-5 text-white" />
          </div>
          <div className="leading-tight hidden sm:block">
            <div className="font-serif text-emerald-900 text-lg font-semibold">Win With Meditation</div>
            <div className="text-[10px] uppercase tracking-widest text-emerald-700/70">winwithmeditation.com</div>
          </div>
        </button>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((n) => (
            <button
              key={n.id}
              onClick={() => goto(n)}
              className="inline-flex items-center gap-2 px-3 py-2 rounded-full text-sm text-emerald-900 hover:bg-emerald-50 transition-colors"
            >
              <n.icon className="w-4 h-4 text-emerald-700" />
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={onAdminClick}
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-900 text-white text-sm hover:bg-emerald-800 transition-colors shadow-sm"
          >
            <Lock className="w-4 h-4" /> Admin Portal
          </button>
          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 rounded-lg hover:bg-emerald-50 text-emerald-900"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-emerald-100 bg-white">
          <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col gap-1">
            {navItems.map((n) => (
              <button
                key={n.id}
                onClick={() => goto(n)}
                className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-emerald-900 hover:bg-emerald-50 text-sm"
              >
                <n.icon className="w-4 h-4 text-emerald-700" />
                {n.label}
              </button>
            ))}
            <button
              onClick={() => { setOpen(false); onAdminClick(); }}
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg bg-emerald-900 text-white text-sm mt-1"
            >
              <Lock className="w-4 h-4" /> Admin Portal
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
